// extracted by mini-css-extract-plugin
export default {"container":"text-block_container__WnUYx","title":"text-block_title__CbCR3","desc":"text-block_desc__GMx0h"};